var v1='<table class=lumx-table ng-class=lx.getClasses() ng-transclude></table>';
angular.module('lumx.table').run(['$templateCache', function ($templateCache) {$templateCache.put('table.html', v1);}]);
module.exports=v1